export default "__VITE_ASSET__B$8vS2dL__"